module.exports = __webpack_public_path__ + "a0cc54967e18587104d02e70f1df8233.pdf";